<template>
  <v-container grid-list-md fluid pa-0>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <v-card class="px-2">
          <v-card-title>
            <span class="title">{{formTitle}}</span>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-form v-model="valid" ref="form">
              <v-container grid-list-md fluid>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-text-field
                      v-model="editedCategory.name"
                      :rules="[required]"
                      label="Name"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12 class="text-xs-right">
                    <v-spacer></v-spacer>
                    <v-btn flat @click="close">Cancel</v-btn>
                    <v-btn
                      class="mx-0"
                      :disabled="!valid"
                      :loading="saving"
                      color="primary"
                      @click="save"
                    >Save</v-btn>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-layout>
    <v-layout
      row
      wrap
      align-center
      justify-end
      :class="{'rt-5': $vuetify.breakpoint.name !== 'xs'}"
    >
      <v-flex xs12 sm6 md4 mx-2 class="pointer-event-auto">
        <v-text-field
          prepend-inner-icon="mdi-magnify"
          label="Search"
          v-model="search"
          hide-details
          single-line
          outline
          class="rounded"
        >
          <v-tooltip top slot="append-outer">
            <v-icon
              class="mx-2"
              medium
              slot="activator"
              @click="dialog = true"
              color="secondary"
            >mdi-plus-circle</v-icon>

            <span>New Category</span>
          </v-tooltip>
        </v-text-field>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
          :search="search"
          :headers="headers"
          :items="categories"
          disable-initial-sort
          :rows-per-page-items="per_page"
        >
          <template slot="items" slot-scope="props">
            <tr>
              <td>{{props.item.id}}</td>
              <td>{{ props.item.name }}</td>

              <td>
                <v-tooltip top>
                  <v-icon
                    slot="activator"
                    class="mx-1"
                    @click="confirmDelete(props.item)"
                  >mdi-delete-outline</v-icon>
                  <span>Delete</span>
                </v-tooltip>

                <v-tooltip top>
                  <v-icon
                    slot="activator"
                    class="mx-1"
                    @click="editCategory(props.item)"
                  >mdi-pencil-outline</v-icon>
                  <span>Edit</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  middleware: "reception",
  data() {
    return {
      category: {},
      required: v => !!v || "This field is required.",
      valid: true,
      defaultCategory: {
        name: ""
      },
      editedCategory: {
        name: ""
      },
      search: "",
      editedIndex: -1,
      dialog: false,
      saving: false,
      headers: [
        { text: "#", value: "id" },
        { text: "Category Name", value: "name" },
        { text: "", value: "name", sortable: false, width: 200 }
      ]
    };
  },
  computed: {
    categories() {
      return this.$store.getters["base/expenseCategories"];
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add New Category" : "Edit Category";
    }
  },

  methods: {
    close() {
      this.saving = false;
      this.dialog = false;
      this.$refs.form.reset();
      Object.assign(this.editedCategory, this.defaultCategory);
      this.editedIndex = -1;
    },

    async save() {
      if (this.$refs.form.validate()) {
        this.saving = true;
        if (this.editedIndex > -1) {
          await this.axios.put(
            `api/expense_categories/${this.editedCategory.id}`,
            this.editedCategory
          );
        } else {
          await this.axios.post("api/expense_categories", this.editedCategory);
        }

        this.$store.dispatch("base/loadExpenseCategories", true);
        this.close();
      }
    },

    editCategory(category) {
      this.editedIndex = category.id;
      Object.assign(this.editedCategory, category);
      this.dialog = true;
    },

    confirmDelete(category) {
      const params = {
        title: `Delete "${category.name}"`,
        message: `Are you sure, you want to delete the category "${
          category.name
        }"?`,
        // typeText: true,
        mode: "delete",
        onConfirm: () => this.deleteCategory(category)
      };

      this.$modal.show(params);
    },

    deleteCategory(category) {
      this.axios
        .delete(`api/expense_categories/${category.id}`)
        .then(result => {
          this.$store.dispatch("base/loadExpenseCategories", true);
        })
        .catch(err => {
          this.$snackbar.error("Could not delete this category.");
        });
    }
  },
  mounted() {
    this.$store.dispatch("base/loadExpenseCategories");
  }
};
</script>

<style scoped>
</style>